import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { BRAND } from "../mock";

const LINKS = [
  {
    title: "Explore",
    items: [
      { label: "Home", to: "/" },
      { label: "Packages", to: "/packages" },
      { label: "Build Your Plan", to: "/build" },
      { label: "About", to: "/about" },
      { label: "Book a Call", to: "/book" },
    ],
  },
  {
    title: "Pillars",
    items: [
      { label: "Nutrition", to: "/build?pillar=nutrition" },
      { label: "Strength & Mobility", to: "/build?pillar=strength" },
      { label: "Endurance", to: "/build?pillar=endurance" },
      { label: "Medical", to: "/build?pillar=medical" },
      { label: "Wellness", to: "/build?pillar=wellness" },
      { label: "Longevity & Grooming", to: "/build?pillar=longevity" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-[var(--lc-ink)] text-[var(--lc-cream)]">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-20 lg:pt-24 pb-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 pb-14 lg:pb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 leading-none">
              <span className="font-serif-display text-3xl tracking-tight">LONGEV</span>
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--lc-moss)]" />
              <span className="font-serif-display italic text-2xl tracking-tight">circle</span>
            </div>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-white/75">
              Basel's first fully integrated longevity ecosystem. Six pillars of
              elite health — one cohesive coaching plan.
            </p>
            <div className="mt-7 space-y-3 text-sm">
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2.5 text-white/85 hover:text-[var(--lc-sand)] transition-colors">
                <Mail className="h-4 w-4" /> {BRAND.email}
              </a>
              <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 text-white/85 hover:text-[var(--lc-sand)] transition-colors">
                <Instagram className="h-4 w-4" /> {BRAND.instagramHandle}
              </a>
              <div className="flex items-center gap-2.5 text-white/85">
                <MapPin className="h-4 w-4" /> {BRAND.location}
              </div>
            </div>
          </div>
          {LINKS.map((col) => (
            <div key={col.title} className="lg:col-span-3">
              <div className="eyebrow text-[var(--lc-sand)] mb-5">{col.title}</div>
              <ul className="space-y-3">
                {col.items.map((it) => (
                  <li key={it.label}>
                    <Link to={it.to} className="text-[14px] text-white/85 hover:text-[var(--lc-sand)] transition-colors">
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="lg:col-span-1" />
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} LONGEV CIRCLE. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy</a>
            <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy-link">Privacy Policy</Link>
            <a href="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms</a>
            <a href="#imprint" className="hover:text-white">Imprint</a>
          </div>
        </div>

        <div className="mt-10 font-serif-display text-[clamp(80px,18vw,260px)] leading-[0.85] tracking-tight text-white/[0.05] select-none pointer-events-none">
          LONGEV
        </div>
      </div>
    </footer>
  );
}
